import { useCallback } from 'react';

export default function Wave({
  amplitude,
  frequency,
  width,
  height,
  color,
  strokeWidth,
  className = '',
}) {
  const generateCosineWavePoints = useCallback(
    (amplitude, frequency, width, height) => {
      const points = [];
      const step = width / 100; // Adjust step for more or less detail

      for (let x = 0; x < width; x += step) {
        const y =
          height / 2 + amplitude * Math.cos(((2 * Math.PI) / frequency) * x);
        points.push(`${x},${y}`);
      }

      return points.join(' ');
    },
    [amplitude, frequency, width, height]
  );

  const points = generateCosineWavePoints(amplitude, frequency, width, height);

  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
